import { render, staticRenderFns } from "./CircleConferenceDetail.vue?vue&type=template&id=53906120&scoped=true"
import script from "./CircleConferenceDetail.vue?vue&type=script&lang=js"
export * from "./CircleConferenceDetail.vue?vue&type=script&lang=js"
import style0 from "./CircleConferenceDetail.vue?vue&type=style&index=0&id=53906120&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53906120",
  null
  
)

export default component.exports